export default __webpack_public_path__ + "static/media/planet3.f97778d8.webp";